import { useGetChargeSlab } from '@/features/configuration-management/charge-management/slabs/hooks/useGetChargeSlab';
import { ChargeCategoryTable } from '@/features/configuration-management/charge-management/slabs/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['fromAmount', 'toAmount', 'chargeType', 'chargeValue', 'minChargeValue', 'maxChargeValue', 'status']),
  desc: z.boolean(),
});

const CategorySlabSearchSchema = z.object({
  breadcrumbReturnTo: z.string().optional(),

  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),
  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
  agentType: z.coerce.string().optional(),
  subCategoryId: z.coerce.string().optional(),
  q: z
    .any()
    .optional()
    .transform((val) => (val == null ? undefined : String(val))),
});

export const Route = createFileRoute('/(app)/configuration-management/charges/$categoryId/slabs/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => CategorySlabSearchSchema.parse(search),
});

function RouteComponent() {
  const { data, isLoading, meta } = useGetChargeSlab();
  const { categoryName } = Route.useSearch();
  return <ChargeCategoryTable data={data} isLoading={isLoading} pagination={meta} categoryName={categoryName} />;
}
